import { defineKeyframes } from "@pandacss/dev";

export const keyframes = defineKeyframes({
  aromaButtonLoading: {
    "0%, 10%": {
      backgroundPositionX: "200%",
    },
    "49%": {
      backgroundPositionX: "100%",
    },
    "51%": {
      backgroundPositionX: "0%",
    },
    "90%, 100%": {
      backgroundPositionX: "-100%",
    },
  },
  fadeIn: {
    "0%": { opacity: "0" },
    "100%": { opacity: "1" },
  },
  fadeOut: {
    "0%": { opacity: "1" },
    "100%": { opacity: "0" },
  },
  "slide-in-bottom": {
    "0%": { transform: "translateY(100%)" },
    "100%": { transform: "translateY(0%)" },
  },
  "slide-out-bottom": {
    "0%": { transform: "translateY(0%)" },
    "100%": { transform: "translateY(100%)" },
  },
  "slide-in-top-subtle": {
    "0%": { transform: "translateY(-15%)" },
    "100%": { transform: "translateY(0%)" },
  },
  "slide-out-top-subtle": {
    "0%": { transform: "translateY(0%)" },
    "100%": { transform: "translateY(-15%)" },
  },
  "slide-in-right": {
    "0%": { transform: "translateX(100%)" },
    "100%": { transform: "translateX(0%)" },
  },
  "slide-out-right": {
    "0%": { transform: "translateX(0%)" },
    "100%": { transform: "translateX(100%)" },
  },
  skeletonLoading: {
    "0%, 20%": {
      backgroundPositionX: "200%",
    },
    "50%, 70%": {
      backgroundPositionX: "50%",
    },
    "100%": {
      backgroundPositionX: "-200%",
    },
  },
  horizontalLoader: {
    "0%": { left: 0 },
    "25%": { left: "40%" },
    "50%": { left: "80%" },
    "75%": { left: "40%" },
    "100%": { left: 0 },
  },
  rotateCircle: {
    "0%": {
      transform: "rotate(0deg)",
    },
    "100%": {
      transform: "rotate(360deg)",
    },
  },
});
